import { Link } from 'react-router-dom';
import './Home.css';

export function Home() {
  return (
    <div className="home-page">

      {/* nav */}
      <nav className="hp-nav">
        <div className="hp-nav-inner">
          <Link className="hp-brand" to="/">
            <span className="hp-brand-mark" aria-hidden="true">
              <span className="caret">&gt;</span><span className="cursor"></span>
            </span>
            <span className="hp-brand-text">
              <span className="hp-brand-name">Web<b>Admin</b></span>
              <span className="hp-brand-tag">Server Management</span>
            </span>
          </Link>
          <div className="hp-nav-links">
            <a href="#modules">Modules</a>
            <a href="#philosophy">Philosophy</a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer">GitHub</a>
          </div>
          <Link className="hp-nav-cta" to="/login">
            Sign in
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </Link>
        </div>
      </nav>

      {/* hero */}
      <section className="hp-hero">
        <div className="hp-hero-bg" />
        <div className="hp-hero-grid-bg" />
        <div className="hp-hero-inner">
          <div>
            <span className="hp-eyebrow"><span className="pulse" />v0.7.3 · 14 services online</span>
            <h1 className="hp-hero-title">One pane to break <span className="accent">them all.</span></h1>
            <p className="hp-hero-sub">
              WebAdmin is the homelab cockpit you keep meaning to build. Servers, jobs, databases, and
              half-finished side projects — all on one dashboard, all one ssh-into-the-router away from
              chaos. (We've debugged the chaos. Mostly.)
            </p>
            <div className="hp-hero-ctas">
              <Link className="hp-btn hp-btn-primary" to="/dashboard">
                Open Dashboard
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
              </Link>
              <a className="hp-btn hp-btn-outline" href="#modules">
                Tour the modules
                <span className="kbd">↓</span>
              </a>
            </div>
            <div className="hp-micro-trust">
              <span>self-hosted</span><span>·</span>
              <span>single binary</span><span>·</span>
              <span>zero telemetry</span>
            </div>
          </div>

          <div className="hp-hero-art" aria-hidden="true">
            <svg viewBox="0 0 540 540">
              <defs>
                <radialGradient id="coreGlow" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="#e53935" stopOpacity="0.55" />
                  <stop offset="60%" stopColor="#e53935" stopOpacity="0.10" />
                  <stop offset="100%" stopColor="#e53935" stopOpacity="0" />
                </radialGradient>
              </defs>

              <circle cx="270" cy="270" r="240" fill="url(#coreGlow)" />

              <g className="ring ring-3" stroke="rgba(255,255,255,0.06)" strokeWidth="1" fill="none">
                <circle cx="270" cy="270" r="230" />
              </g>
              <g className="ring ring-2" stroke="rgba(255,255,255,0.10)" strokeWidth="1" fill="none" strokeDasharray="2 6">
                <circle cx="270" cy="270" r="180" />
              </g>
              <g className="ring ring-1" stroke="rgba(229,57,53,0.35)" strokeWidth="1.2" fill="none">
                <circle cx="270" cy="270" r="130" />
                <circle cx="270" cy="140" r="3.5" fill="#e53935" />
                <circle cx="380" cy="320" r="2.5" fill="#ff8a87" />
                <circle cx="200" cy="340" r="2.5" fill="#ff8a87" />
              </g>

              <g stroke="rgba(255,255,255,0.07)" strokeWidth="1" strokeDasharray="3 4">
                <line x1="270" y1="270" x2="270" y2="80" />
                <line x1="270" y1="270" x2="460" y2="170" />
                <line x1="270" y1="270" x2="470" y2="380" />
                <line x1="270" y1="270" x2="270" y2="470" />
                <line x1="270" y1="270" x2="80" y2="380" />
                <line x1="270" y1="270" x2="80" y2="170" />
              </g>

              {/* terminal core */}
              <g className="core">
                <rect x="190" y="200" width="160" height="140" rx="14" fill="#1a1a1c" stroke="rgba(229,57,53,0.5)" strokeWidth="1.5" />
                <rect x="190" y="200" width="160" height="22" rx="14" fill="rgba(255,255,255,0.03)" />
                <rect x="190" y="214" width="160" height="8" fill="rgba(255,255,255,0.03)" />
                <circle cx="202" cy="211" r="3" fill="#e53935" />
                <circle cx="213" cy="211" r="3" fill="#ff9800" />
                <circle cx="224" cy="211" r="3" fill="#4caf50" />
                <text x="270" y="215" textAnchor="middle" className="terminal-line" fill="#9e9e9e">webadmin@host</text>
                <text x="200" y="244" className="terminal-line" fill="#bdbdbd">$ systemctl status all</text>
                <text x="200" y="262" className="terminal-line" fill="#4caf50">  ● 14 active · 0 failed</text>
                <text x="200" y="280" className="terminal-line" fill="#bdbdbd">$ wp list --phase 7</text>
                <text x="200" y="298" className="terminal-line" fill="#ff8a87">  WP98  WP103 WP104</text>
                <text x="200" y="316" className="terminal-line" fill="#bdbdbd">$ </text>
                <rect x="216" y="308" width="7" height="10" fill="#e53935" className="blink" />
              </g>

              {/* service nodes */}
              <g className="node n1" transform="translate(270 80)">
                <circle r="22" fill="#1a1a1c" stroke="rgba(229,57,53,0.5)" />
                <g transform="translate(-9 -9)" stroke="#ff8a87" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="0" y="0" width="8" height="10" rx="1.5" />
                  <rect x="10" y="0" width="8" height="6" rx="1.5" />
                  <rect x="0" y="12" width="8" height="6" rx="1.5" />
                  <rect x="10" y="8" width="8" height="10" rx="1.5" />
                </g>
              </g>
              <g className="node n2" transform="translate(460 170)">
                <circle r="22" fill="#1a1a1c" stroke="rgba(229,57,53,0.5)" />
                <g transform="translate(-10 -7)" stroke="#ff8a87" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 5 h14 a4 4 0 0 1 4 4 v0 a4 4 0 0 1 -4 4 h-2 l-2 -2 h-6 l-2 2 h-2 a4 4 0 0 1 -4 -4 v0 a4 4 0 0 1 4 -4 z" />
                  <line x1="6" y1="9" x2="9" y2="9" />
                  <line x1="7.5" y1="7.5" x2="7.5" y2="10.5" />
                  <circle cx="15" cy="9" r="0.6" fill="#ff8a87" />
                </g>
              </g>
              <g className="node n3" transform="translate(470 380)">
                <circle r="22" fill="#1a1a1c" stroke="rgba(229,57,53,0.5)" />
                <g transform="translate(-9 -10)" stroke="#ff8a87" strokeWidth="1.6" fill="none">
                  <ellipse cx="9" cy="3" rx="9" ry="3" />
                  <path d="M0 3 v6 a9 3 0 0 0 18 0 v-6" />
                  <path d="M0 9 v6 a9 3 0 0 0 18 0 v-6" />
                </g>
              </g>
              <g className="node n4" transform="translate(270 470)">
                <circle r="22" fill="#1a1a1c" stroke="rgba(229,57,53,0.5)" />
                <g transform="translate(-10 -10)" stroke="#ff8a87" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m20 16 -9 5 -9 -5 V8 l9 -5 9 5 z" />
                  <path d="M2.27 7.96 11 13.01 19.73 7.96" />
                  <path d="M11 22.08 V13" />
                </g>
              </g>
              <g className="node n5" transform="translate(80 380)">
                <circle r="22" fill="#1a1a1c" stroke="rgba(229,57,53,0.5)" />
                <g transform="translate(-10 -10)" stroke="#ff8a87" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="10" cy="10" r="8" />
                  <path d="M10 5 v5 l3 2" />
                </g>
              </g>
              <g className="node n6" transform="translate(80 170)">
                <circle r="22" fill="#1a1a1c" stroke="rgba(229,57,53,0.5)" />
                <g transform="translate(-10 -7)" stroke="#ff8a87" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 12 c0 -5 3 -9 7 -9 c4 0 7 4 7 9" />
                  <path d="M3 12 v2 l3 -1" />
                  <path d="M17 12 v2 l-3 -1" />
                </g>
              </g>

              {/* animated packets */}
              <circle className="packet packet-1" r="3" style={{ offsetPath: "path('M 270 270 L 270 80')", offsetRotate: '0deg' } as React.CSSProperties} />
              <circle className="packet packet-2" r="2.5" style={{ offsetPath: "path('M 270 270 L 470 380')", offsetRotate: '0deg' } as React.CSSProperties} />
              <circle className="packet packet-3" r="2.5" style={{ offsetPath: "path('M 270 270 L 80 170')", offsetRotate: '0deg' } as React.CSSProperties} />
            </svg>
          </div>
        </div>
      </section>

      {/* stats strip */}
      <div className="hp-stats">
        <div className="hp-stat">
          <div className="hp-stat-num"><span className="accent">104</span></div>
          <div className="hp-stat-label">Work Packages tracked</div>
          <div className="hp-stat-sub">+12 this week · 7 in flight</div>
        </div>
        <div className="hp-stat">
          <div className="hp-stat-num">99.9<span style={{ fontSize: '20px', color: 'var(--text-muted)' }}>%</span></div>
          <div className="hp-stat-label">Uptime, last 30d</div>
          <div className="hp-stat-sub">the .1% was a power cut</div>
        </div>
        <div className="hp-stat">
          <div className="hp-stat-num">14</div>
          <div className="hp-stat-label">Services online</div>
          <div className="hp-stat-sub">0 failed · 2 restarting</div>
        </div>
        <div className="hp-stat">
          <div className="hp-stat-num">0</div>
          <div className="hp-stat-label">Tabs left open</div>
          <div className="hp-stat-sub">because it's all here now</div>
        </div>
      </div>

      {/* modules */}
      <section className="hp-section" id="modules">
        <div className="hp-section-head">
          <div>
            <div className="hp-section-eyebrow">// modules</div>
            <h2 className="hp-section-title">Four panels. One terrible idea well-executed.</h2>
          </div>
          <p className="hp-section-aside">
            Every module ships out of the box. Drop-in. Opinionated. Refuses to be a microservice.
          </p>
        </div>

        <div className="hp-modules">
          <Link className="hp-module" to="/dashboard">
            <div className="hp-module-head">
              <span className="hp-module-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="8" height="10" rx="1.5" />
                  <rect x="13" y="3" width="8" height="6" rx="1.5" />
                  <rect x="3" y="15" width="8" height="6" rx="1.5" />
                  <rect x="13" y="11" width="8" height="10" rx="1.5" />
                </svg>
              </span>
              <span className="hp-module-name">System Dashboard</span>
              <span className="hp-module-tag">/dashboard</span>
            </div>
            <p className="hp-module-desc">CPU, RAM, disk, network — the four horsemen of "why is it slow?". Live tiles, click-through to history, no Grafana required.</p>
            <ul className="hp-module-bullets">
              <li>top 1 -bn1 | head -20</li>
              <li>df -h /var /home /games</li>
              <li>tail -f /var/log/everything.log</li>
            </ul>
            <span className="hp-module-link">Peek inside</span>
          </Link>

          <Link className="hp-module" to="/games">
            <div className="hp-module-head">
              <span className="hp-module-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9 h14 a4 4 0 0 1 4 4 v0 a4 4 0 0 1 -4 4 h-2 l-2 -2 h-6 l-2 2 h-2 a4 4 0 0 1 -4 -4 v0 a4 4 0 0 1 4 -4 z" />
                  <line x1="6" y1="13" x2="9" y2="13" />
                  <line x1="7.5" y1="11.5" x2="7.5" y2="14.5" />
                  <circle cx="15" cy="13" r="1" />
                  <circle cx="17" cy="11" r="1" />
                </svg>
              </span>
              <span className="hp-module-name">Game Servers</span>
              <span className="hp-module-tag">/games</span>
            </div>
            <p className="hp-module-desc">Start, stop, back up, and apologise to your friends in chat — all without SSH. Per-game config, savegame browser, RCON console included.</p>
            <ul className="hp-module-bullets">
              <li>./minecraft start --backup-first</li>
              <li>rcon "say server back in 5"</li>
              <li>steamcmd +app_update 380870</li>
            </ul>
            <span className="hp-module-link">Spin one up</span>
          </Link>

          <Link className="hp-module" to="/mysql">
            <div className="hp-module-head">
              <span className="hp-module-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <ellipse cx="12" cy="5" rx="9" ry="3" />
                  <path d="M3 5 v6 a9 3 0 0 0 18 0 v-6" />
                  <path d="M3 11 v6 a9 3 0 0 0 18 0 v-6" />
                </svg>
              </span>
              <span className="hp-module-name">MySQL Browser</span>
              <span className="hp-module-tag">/mysql</span>
            </div>
            <p className="hp-module-desc">A query editor and a tree of databases that won't gaslight you. Imports, exports, and a log drawer for the times you definitely did not DROP TABLE.</p>
            <ul className="hp-module-bullets">
              <li>SELECT * FROM regrets LIMIT 10;</li>
              <li>mysqldump --single-transaction</li>
              <li>SHOW PROCESSLIST;</li>
            </ul>
            <span className="hp-module-link">Run a query</span>
          </Link>

          <Link className="hp-module" to="/development">
            <div className="hp-module-head">
              <span className="hp-module-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m21 16 -9 5 -9 -5 V8 l9 -5 9 5 z" />
                  <path d="M3.27 7.96 12 13.01 20.73 7.96" />
                  <path d="M12 22.08 V12" />
                </svg>
              </span>
              <span className="hp-module-name">Work Packages</span>
              <span className="hp-module-tag">/development</span>
            </div>
            <p className="hp-module-desc">Drop a markdown file in. Out comes a tracked WP with phase, priority, subtasks, and a Claim button for the one engineer who will actually finish it.</p>
            <ul className="hp-module-bullets">
              <li>cat WP104.md | wp upload</li>
              <li>wp claim --as me</li>
              <li>wp ship --skip-tests # dont</li>
            </ul>
            <span className="hp-module-link">Open the queue</span>
          </Link>
        </div>
      </section>

      {/* philosophy */}
      <section className="hp-philosophy" id="philosophy">
        <div className="hp-philosophy-inner">
          <div>
            <div className="hp-section-eyebrow">// philosophy</div>
            <p className="hp-quote">
              Built for the ops engineer who said <span className="strike">"I'll just write a quick script"</span> at 11pm and woke up six hours later with <span className="accent">a dashboard, a webhook fleet, and 14 systemd units.</span>
            </p>
          </div>
          <div className="hp-principles">
            <div className="hp-principle">
              <span className="hp-principle-num">01</span>
              <div>
                <div className="hp-principle-title">Single binary, single config</div>
                <p className="hp-principle-body">No Helm chart, no orchestrator, no service mesh. Just a process you can <code>systemctl restart</code> in good conscience.</p>
              </div>
            </div>
            <div className="hp-principle">
              <span className="hp-principle-num">02</span>
              <div>
                <div className="hp-principle-title">Boring tech on purpose</div>
                <p className="hp-principle-body">Postgres-flavoured MySQL, cron, systemd, plain ssh. If it survived 1998, it'll survive your homelab.</p>
              </div>
            </div>
            <div className="hp-principle">
              <span className="hp-principle-num">03</span>
              <div>
                <div className="hp-principle-title">Every screen has a keyboard shortcut</div>
                <p className="hp-principle-body">If you have to use a mouse twice in a row, that's a bug. <span className="hp-kbd">⌘K</span> opens everything.</p>
              </div>
            </div>
            <div className="hp-principle">
              <span className="hp-principle-num">04</span>
              <div>
                <div className="hp-principle-title">Logs over metrics over telemetry</div>
                <p className="hp-principle-body">We tail. We don't phone home. Your dashboard lives on your hardware, full stop.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="hp-cta-strip">
        <h2>Stop tab-juggling. <span style={{ color: 'var(--primary)' }}>Start tab-firing.</span></h2>
        <p>One login. Every server, job, query, and half-baked side-project under a single roof. The IKEA flatpack of homelab dashboards — assembly mostly painless.</p>
        <div className="hp-hero-ctas">
          <Link className="hp-btn hp-btn-primary" to="/dashboard">
            Open Dashboard
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </Link>
          <a className="hp-btn hp-btn-outline" href="https://github.com" target="_blank" rel="noopener noreferrer">View on GitHub</a>
        </div>
      </section>

      {/* footer */}
      <footer className="hp-footer">
        <div className="hp-footer-inner">
          <div className="hp-footer-brand">
            <div className="hp-brand">
              <span className="hp-brand-mark" aria-hidden="true">
                <span className="caret">&gt;</span><span className="cursor" />
              </span>
              <span className="hp-brand-text">
                <span className="hp-brand-name">Web<b>Admin</b></span>
                <span className="hp-brand-tag">Server Management</span>
              </span>
            </div>
            <p>Self-hosted control panel for people who run their own stuff. No cloud, no contracts, no calls home.</p>
          </div>

          <div className="hp-footer-cols">
            <div className="hp-footer-col">
              <h4>Modules</h4>
              <ul>
                <li><Link to="/dashboard">System dashboard</Link></li>
                <li><Link to="/games">Game servers</Link></li>
                <li><Link to="/mysql">MySQL browser</Link></li>
                <li><Link to="/development">Work Packages</Link></li>
                <li><Link to="/cron">Cron jobs</Link></li>
                <li><Link to="/discord">Discord webhooks</Link></li>
                <li><Link to="/services">Services &amp; logs</Link></li>
                <li><Link to="/users">Users &amp; SSH keys</Link></li>
                <li><Link to="/claude">Claude terminal</Link></li>
              </ul>
            </div>
            <div className="hp-footer-col">
              <h4>Product</h4>
              <ul>
                <li><Link to="/dashboard">Dashboard</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/settings">Settings</Link></li>
                <li><Link to="/audit">Audit log</Link></li>
              </ul>
            </div>
            <div className="hp-footer-col">
              <h4>System</h4>
              <ul>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/webserver">Webserver</Link></li>
                <li><Link to="/firewall">Firewall</Link></li>
                <li><Link to="/backups">Backups</Link></li>
                <li><Link to="/security">Security</Link></li>
              </ul>
            </div>
            <div className="hp-footer-col">
              <h4>Project</h4>
              <ul>
                <li><a href="https://github.com" target="_blank" rel="noopener noreferrer">GitHub</a></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/help/flow">Flow docs</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="hp-footer-bottom">
          <span>© 2026 WebAdmin · v0.7.3</span>
          <span className="right">
            <Link to="/audit">Audit</Link>
            <Link to="/security">Security</Link>
            <Link to="/about">About</Link>
          </span>
        </div>
      </footer>

    </div>
  );
}
